module.exports = {
  mode: 'hetzner',
  apiUrl: 'https://wsapi.hetzner.wannasport.com/api',
  wsApiUrl: 'https://wsapi.hetzner.wannasport.com/api',
  googleApiKey: 'AIzaSyBixcFsmrOmqHGAvxyWD4kwC4CGc0l-AtY',
  googleLoginClientId: '1069111212197-59ovsv7rp1dnskgeksh9leu5svvuvnvb.apps.googleusercontent.com',
  intercomAppId: 'xe9ttx0v',
  adyen: {
    domain: 'ca-test.adyen.com'
  }
};
